import axios, { AxiosResponse } from "axios";
import { APP_Config } from "../../helpers/AppConfig";
import Service from "../../services";
import { configFormData, configFormDataTimeOut, modifyFormData } from "../../helpers/ServiceHelpers";
import { IIngestKdbInput, IKDBProjectInput, IUserQueryInput, ingest_training_data } from "../../models/APIModels";


class DataAnalyticsService extends Service {
  base_url = APP_Config()?.REACT_APP_DATA_ANALYTICS_URL;

  da_ingest_kdb = (payload: IIngestKdbInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_ingest_kdb`, formData, configFormData)
  }

  da_upload_csv = (payload: IIngestKdbInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_upload_csv`, formData, configFormData)
  }

  da_get_userquery = (payload: IUserQueryInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_get_userquery`, formData, configFormData)
  }

  da_ontology_setup_generation = (payload: IUserQueryInput, data: any) => {
    const headers = {
      'project-name': payload?.project_name,
      'project-type': payload?.project_type,
      'kdb-name': payload?.kdbName,
      'version': payload?.version,
      'file-name': payload?.file_name
    }
    return axios.post(`${this.base_url}/da_ontology_setup_generation`, data, {
      headers: headers 
    })
  }

  da_ontology_network_x_ingest_kdb = (payload: IUserQueryInput, data: any) => {
    const headers = {
      'project-name': payload?.project_name,
      'project-type': payload?.project_type,
      'kdb-name': payload?.kdbName,
      'version': payload?.version,
      'file_name': payload?.file_name,
      'project-id': payload?.project_id,
    }
    return axios.post(`${this.base_url}/da_ontology_network_x_ingest_kdb`, data, {
      headers: headers 
    })
  }
  
  da_get_networkx_userquery = (payload: IUserQueryInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_get_networkx_userquery`, formData, configFormDataTimeOut)
  }

  da_get_user_query_plots = (payload: IUserQueryInput): Promise<AxiosResponse<any>> => {
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/da_get_user_query_plots`, formData, configFormDataTimeOut)
  }

  ingest_training_data = (payload:ingest_training_data):Promise<AxiosResponse<any>> => {
    return axios.post(`${this.base_url}/ingest_training_data`, payload)
  }

  query_with_agent = (payload:any):Promise<AxiosResponse<any>> =>{
    let formData = new FormData();
    formData = modifyFormData(payload, formData)
    return axios.post(`${this.base_url}/query_with_agent`, formData, configFormData)
  }

  save_insight_status = (payload:any):Promise<AxiosResponse<any>> =>{
    return axios.post(`${this.base_url}/save_insight_status`,payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}

export default DataAnalyticsService;
